import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import PageTitle from "../../components/Ui/PageTitle";
import { OrderStatus, TApiOrder } from "../../api/endpoints/Order";
import OrderList from "../../components/OrderList/index";
import * as Api from "../../api";

const PendingOrders = () => {
  const [orders, setOrders] = useState<Array<TApiOrder> | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);

    Api.Order.list({ status: OrderStatus.SUBMITTED, limit: 1000 })
      .then(response => {
        setOrders(response.results);
        setLoading(false);
        setError(false);
      })
      .catch(() => {
        setError(true);
      });
  }, []);

  return (
    <Fragment>
      <Row>
        <Col>
          <PageTitle title="Pending orders" />
        </Col>
      </Row>
      <Row>
        <Col>
          <OrderList
            orders={orders ?? []}
            loading={loading}
            error={error}
          />
        </Col>
      </Row>
    </Fragment>
  )
}

export default PendingOrders;
